import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types'
import styles from "./topTracks.module.css"

const TopTracksCompNew = (props) => {
  const [topTracks, setTopTracks] = useState([]);

  useEffect(() => {
    const getTopTracks = async () => {
      //access top tracks
      const topTracksAllTimeRes = await fetch(
        "https://api.spotify.com/v1/me/top/tracks?limit=50&time_range=long_term&offset=0",
        {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("accessToken")
          }
        }
      );
      let topTracksAllTimeData = await topTracksAllTimeRes.json();

      //set Alltime top tracks to state
      setTopTracks(topTracksAllTimeData.items)
    }
    getTopTracks()
  }, []);

  return (
    <div className={styles.topTracks}>
      <h3>Your Top 50:</h3>
      <ul>
        {topTracks.map(track => (
          <li className={styles.trackItem} key={track.uri}>
            <div className={styles.trackName}>{track.name}</div>

            <div className={styles.trackArtist}>
              {Object.keys(track.artists).length !== 1
                ? track.artists.map((artist, i) =>
                    i < Object.keys(track.artists).length - 1
                      ? artist.name + ", "
                      : artist.name
                  )
                : track.artists[0].name}
            </div>

            <div className={styles.trackAlbum}>{track.album.name}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

TopTracksCompNew.propTypes = {

}

export default TopTracksCompNew;
